import mitt from 'mitt'

const emitter = mitt()

export const AppEvents = {
	Navigate: 'app:navigate',
	ShowToast: 'app:show_toast',
	HideToast: 'app:hide_toast',
	AuthStateChange: 'app:auth_state_change',
}

export default emitter

